import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface FunctionState {
  isFunctionsDirty: boolean;
}

const initialState: FunctionState = {
  isFunctionsDirty: false,
};

const functionsFormSlice = createSlice({
  name: 'functionsForm',
  initialState,
  reducers: {
    setIsFunctionsDirty: (state, id: PayloadAction<boolean>) => {
      state.isFunctionsDirty = id.payload;
    },
  },
});

export const { setIsFunctionsDirty } = functionsFormSlice.actions;

export default functionsFormSlice.reducer;
